import React, { useState } from 'react';
import { FaVolumeHigh } from "react-icons/fa6";
import { IoMenu, IoClose } from "react-icons/io5";
import { FaArrowRight } from "react-icons/fa";
import { NavLink } from 'react-router-dom';


const MobileNav = () => {
  const [menuOpen, setMenuOpen] = useState(false);

    const menuItems = [
      { label: 'HOMEPAGE', link: '/home' },
      { label: 'YOUR PROFILE', link: '/profile' },
      { label: 'HOW TO PLAY', link: '/how-to-play' },
      { label: 'LEADERBOARD', link: '/leaderboard' }, 
  ];

  const toggleMenu = () => setMenuOpen(v => !v);

  return (
    <>
        <nav className='mobile-nav'>
          <div className="left-icon">
              <FaVolumeHigh className='icon'/>
          </div>

          <div className="ham-menu" onClick={toggleMenu}>
              <IoMenu className='icon'/>  
          </div>
        </nav>


        {menuOpen && (
          <section id="mobile-menu" className={`menu ${menuOpen ? 'show' : ''}`}>
            <div className="overlay" role="dialog" aria-modal="true">
              <div className="menu-items">
                <IoClose className="close-icon" onClick={toggleMenu}/>

                {menuItems.map((item, index) => (
                  <NavLink key={item.link} to={item.link} onClick={() => setMenuOpen(false)} className="menu-link">
                    <span>{item.label}</span>
                    <FaArrowRight className="icon" />
                  </NavLink>
                ))}
              </div>
            </div>
          </section>
        )}
        
    </>

  )
}

export default MobileNav